"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findBestPricedSolution = findBestPricedSolution;
const build_packages_1 = require("../build-packages");
const is_logistic_route_possible_1 = require("../is-logistic-route-possible");
const NB_MAX_LOOP = 1000;
function findBestPricedSolution(criteria, nbMaxLoop = NB_MAX_LOOP) {
    const criteriaFiltered = criteria.map(({ logisticOffers, ...criterion }) => {
        const logisticOffersFiltered = logisticOffers.filter((0, is_logistic_route_possible_1.filterLogisticOffersByLogisticRoute)(criterion.selectedRoute));
        if (logisticOffersFiltered.length === 0)
            throw new Error(`No valid logistic offer found for line: ${criterion.lineId}`);
        return {
            ...criterion,
            logisticOffers: logisticOffersFiltered
        };
    });
    const logisticOffersSizeByCriteria = criteriaFiltered.map(criterion => criterion.logisticOffers.length);
    const numberOfPossibilites = logisticOffersSizeByCriteria.reduce((nb, size) => nb * size, 1);
    let solutions = [criteriaFiltered.map(() => 0)];
    let breakParameters = {
        bestPricedSolution: (0, build_packages_1.buildPackages)(convertSolutionToCriterion(criteriaFiltered, solutions[0])),
        nbLoop: 0
    };
    logisticOffersSizeByCriteria.forEach((nbLogisticOffer, criterionIndex) => {
        if (exitLoop(breakParameters, nbMaxLoop))
            return;
        const actualSolutions = [...solutions];
        for (let logisticOfferIndex = 1; logisticOfferIndex < nbLogisticOffer && !exitLoop(breakParameters, nbMaxLoop); logisticOfferIndex += 1) {
            const { breakParameters: foundBreakParameters, solutions: foundSolutions } = duplicateSolutions({
                criteria: criteriaFiltered,
                actualSolutions,
                criterionIndex,
                logisticOfferIndex,
                bestPricedSolution: breakParameters.bestPricedSolution,
                nbLoop: breakParameters.nbLoop,
                nbMaxLoop
            });
            solutions = [...solutions, ...foundSolutions];
            breakParameters = foundBreakParameters;
        }
    });
    return { bestPricedLogisticSplit: breakParameters.bestPricedSolution, solutions, numberOfPossibilites };
}
function duplicateSolutions({ criteria, actualSolutions, bestPricedSolution, criterionIndex, logisticOfferIndex, nbLoop, nbMaxLoop }) {
    const breakParameters = {
        bestPricedSolution,
        nbLoop
    };
    const solutions = [];
    actualSolutions.forEach(actualSolution => {
        breakParameters.nbLoop += 1;
        const modifySolution = [...actualSolution];
        // eslint-disable-next-line security/detect-object-injection
        modifySolution[criterionIndex] = logisticOfferIndex;
        solutions.push(modifySolution);
        const actualPricedSolution = (0, build_packages_1.buildPackages)(convertSolutionToCriterion(criteria, modifySolution));
        if (+actualPricedSolution.totalLogisticCost < +breakParameters.bestPricedSolution.totalLogisticCost) {
            breakParameters.bestPricedSolution = actualPricedSolution;
        }
        // eslint-disable-next-line no-useless-return
        if (exitLoop(breakParameters, nbMaxLoop))
            return;
    });
    return { solutions, breakParameters };
}
function exitLoop(breakParameters, nbMaxLoop) {
    return breakParameters.nbLoop > nbMaxLoop || breakParameters.bestPricedSolution.totalLogisticCost === '0';
}
function convertSolutionToCriterion(criteria, solution) {
    return criteria.map(({ logisticOffers, ...criterion }, criterionIndex) => ({
        ...criterion,
        selectedLogisticOffer: logisticOffers[`${solution[`${criterionIndex}`]}`]
    }));
}
